import { inherits as _inherits, createClass as _createClass, defineProperty as _defineProperty, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { i18n } from '../i18n/translate.js';
import { Button } from './Button/index.js';
import { Flex, Spacer, ButtonGroup } from '@chakra-ui/react';
import { FAIcon } from './fa-icon/component.js';
var InteractiveNotification = /*#__PURE__*/function (_React$Component) {
  function InteractiveNotification() {
    _classCallCheck(this, InteractiveNotification);
    return _callSuper(this, InteractiveNotification, arguments);
  }
  _inherits(InteractiveNotification, _React$Component);
  return _createClass(InteractiveNotification, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        title = _this$props.title,
        body = _this$props.body,
        setCookie = _this$props.setCookie,
        show = _this$props.show,
        decline = _this$props.decline;
      return show ? /*#__PURE__*/React.createElement("div", {
        className: 'inline-notification-banner info'
      }, /*#__PURE__*/React.createElement("div", {
        className: "banner-icon"
      }, /*#__PURE__*/React.createElement(FAIcon, {
        icon: "circle-info"
      })), /*#__PURE__*/React.createElement("div", {
        className: "banner-text foundry"
      }, /*#__PURE__*/React.createElement("h4", {
        className: "f-18 title"
      }, title), /*#__PURE__*/React.createElement("div", {
        className: "body"
      }, body), /*#__PURE__*/React.createElement(Flex, {
        minWidth: "max-content",
        alignItems: "center",
        gap: "2"
      }, /*#__PURE__*/React.createElement(Spacer, null), /*#__PURE__*/React.createElement(ButtonGroup, {
        gap: "2"
      }, /*#__PURE__*/React.createElement(Button, {
        className: "btn-secondary-branded decline-btn",
        "data-action": "decline-cookies",
        "data-attribute": "disagree-button",
        label: i18n.t('Decline'),
        icon: "close",
        onClick: decline,
        renderAsLegacy: true
      }), /*#__PURE__*/React.createElement(Button, {
        className: "btn-primary-branded accept-btn",
        "data-action": "accept-cookies",
        "data-attribute": "agree-button",
        label: i18n.t('I Agree'),
        icon: "check",
        onClick: setCookie,
        renderAsLegacy: true
      }))))) : null;
    }
  }]);
}(React.Component);
_defineProperty(InteractiveNotification, "propTypes", {
  body: PropTypes.string.isRequired,
  title: PropTypes.string,
  show: PropTypes.bool,
  decline: PropTypes.func,
  setCookie: PropTypes.func
});
InteractiveNotification.displayName = "InteractiveNotification";
export { InteractiveNotification };